import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { QUINNY_AI_AVATAR_URL } from '@core';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { SettingsService, User } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FcwidgetService } from 'src/app/core/util/fcwidget.service';

@Component({
  selector: 'header-mobile-dropdown-nav',
  template: `
    <div
      class="alain-default__nav-item show-nav"
      nz-dropdown
      nzPlacement="bottomRight"
      [nzDropdownMenu]="ellipsisMenu"
    >
      <span nz-icon nzType="ellipsis" style="color: white;"></span>
    </div>

    <nz-dropdown-menu #ellipsisMenu="nzDropdownMenu">
      <div nz-menu class="width-sm header-extend">
        <div nz-menu-item (click)="openMarketplace()">
          <i
            nz-icon
            nzIconfont="icon-marketplace-black"
            style="color: white;"
            class="mr-sm"
          ></i>
          Marketplace
        </div>
        <!-- <div nz-menu-item (click)="openChat()">
          <div style="display: flex; align-items: center; gap: 10px;">
            <img
              [src]="quinnyAiAvatarUrl"
              alt="Chat"
              class="chat-icon"
              style="width: auto; height: 15px; cursor: pointer;"
            />
            <div>Quinny AI</div>
          </div>
        </div> -->
        <div nz-menu-item (click)="openUrl()">
          <i nz-icon nzType="question-circle" class="mr-sm"></i>
          Support
        </div>
      </div>
    </nz-dropdown-menu>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderMobileDropdownNavComponent {
  readonly quinnyAiAvatarUrl = QUINNY_AI_AVATAR_URL;

  get user(): User {
    return this.settings.user;
  }

  constructor(
    private settings: SettingsService,
    private modalSrv: NzModalService,
    private router: Router,
    private fcWidget: FcwidgetService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService
  ) {}

  openMarketplace() {
    this.router.navigate(['./marketplace']);
  }

  openChat() {
    const chatbot = document.getElementById('chatbot-window');
    if (chatbot?.style.display === 'block') {
      chatbot.style.display = 'none';
    }
    this.fcWidget.openWithUserContext();
  }

  openUrl() {
    let country = this.settings.user['company'].country;

    if (country === 'PH') {
      window.open(
        `https://support.qne.com.ph/support/solutions/35000142932`,
        '_blank'
      );
    } else if (country === 'MM') {
      window.open(`https://qnemm.freshdesk.com/support/home`, '_blank');
    } else {
      window.open(
        `https://support.qne.com.my/support/solutions/81000205493`,
        '_blank'
      );
    }
  }
}
